/*eslint-disable*/
import React from 'react';
import { Picker } from 'ui-kit';
import * as Styled from './styles';

const DateRangeSubComponent = ({ stateForm, handleStateForm, type = '' }) => {
  return (
    <Styled.DatePanelWrapper>
      <Styled.SubPanelLabel>Within time period</Styled.SubPanelLabel>
      <Styled.PickerWrapper>
        <span>from</span>
        <Picker
          showMonthYearDropdown
          idInput={`startDate-${type}`}
          onChange={(value) => handleStateForm({ value, type, dateType: 'startDate' })}
          selected={stateForm[type].startDate || null}
          inputFor={`startDate-${type}`}
          name={`startDate-${type}`}
          menuPlacement="top"
          required
        />
        <span>to</span>
        <Picker
          showMonthYearDropdown
          idInput={`endDate-${type}`}
          onChange={(value) => handleStateForm({ value, type, dateType: 'endDate' })}
          selected={stateForm[type].endDate || null}
          inputFor={`endDate-${type}`}
          name={`endDate-${type}`}
          menuPlacement="top"
          required
        />
      </Styled.PickerWrapper>
    </Styled.DatePanelWrapper>
  );
};

export default DateRangeSubComponent;
